var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMna2N321Ejwdxsi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1144,
    height: 647,
    viewBox: "0 0 1144 647",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0.5H1136C1140.14 0.5 1143.5 3.85786 1143.5 8V639C1143.5 643.142 1140.14 646.5 1136 646.5H8C3.85787 646.5 0.5 643.142 0.5 639V8C0.5 3.85787 3.85786 0.5 8 0.5Z",
    fill: "white",
    stroke: "#D6DEE8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMna2N321Ejwdxsi);
export default __webpack_public_path__ + "static/media/mna2n321-ejwdxsi.5a627c016f71b7e0ffc746de1109b431.svg";
export { ForwardRef as ReactComponent };